import { render, staticRenderFns } from "./FoFri.vue?vue&type=template&id=5efd439c&"
import script from "./FoFri.vue?vue&type=script&lang=js&"
export * from "./FoFri.vue?vue&type=script&lang=js&"
import style0 from "./FoFri.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports